"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coordinate_attribute_name_1 = require("../../../shared/model/coordinate-attribute-name");
var moment = require("moment/moment");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var diagnosis_service_1 = require("../../service/diagnosis.service");
var CoordinatesDisplayComponent = /** @class */ (function () {
    function CoordinatesDisplayComponent(_diagnosisNotification, _diagnosisService) {
        this._diagnosisNotification = _diagnosisNotification;
        this._diagnosisService = _diagnosisService;
        this.loadingText = 'Carregando...';
        this.unavailableText = 'Indisponível';
        this.running = true;
    }
    CoordinatesDisplayComponent.prototype.ngOnInit = function () {
        if (this._run) {
            this.setEmptyEntities();
            this.getLastHourCoordinates();
            this.observeRestart();
            this.observeVehicle();
        }
    };
    Object.defineProperty(CoordinatesDisplayComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CoordinatesDisplayComponent.prototype, "coordinates", {
        get: function () {
            return this._coordinates;
        },
        set: function (coordinates) {
            this._coordinates = coordinates;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CoordinatesDisplayComponent.prototype, "vehicle", {
        get: function () {
            return this._vehicle;
        },
        set: function (vehicle) {
            this._vehicle = vehicle;
        },
        enumerable: true,
        configurable: true
    });
    CoordinatesDisplayComponent.prototype.observeVehicle = function () {
        var _this = this;
        this._diagnosisNotification.vehicle$
            .subscribe(function (vehicle) {
            _this._vehicle = vehicle;
            _this.getLastHourCoordinates();
            _this.setEmptyEntities();
            _this.running = true;
        });
    };
    CoordinatesDisplayComponent.prototype.observeRestart = function () {
        var _this = this;
        this._diagnosisNotification.restart$
            .subscribe(function () {
            _this.getLastHourCoordinates();
            _this.setEmptyEntities();
            _this.running = true;
        });
    };
    CoordinatesDisplayComponent.prototype.setEmptyEntities = function () {
        this._coordinates = new Array();
    };
    CoordinatesDisplayComponent.prototype.getHeaders = function () {
        var headers = new Array();
        Object.keys(coordinate_attribute_name_1.CoordinateAttributeName).forEach(function (header) {
            headers.push(coordinate_attribute_name_1.CoordinateAttributeName[header]);
        });
        return headers;
    };
    CoordinatesDisplayComponent.prototype.getAttributes = function () {
        return Object.keys(coordinate_attribute_name_1.CoordinateAttributeName);
    };
    CoordinatesDisplayComponent.prototype.getFormattedDate = function (date) {
        if (date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        }
    };
    CoordinatesDisplayComponent.prototype.downloadCoordinates = function () {
        this._diagnosisService.dowloadCoordinates(this._coordinates);
    };
    CoordinatesDisplayComponent.prototype.getLastHourCoordinates = function () {
        var _this = this;
        this._diagnosisService.getLastHourCoordinates(this._vehicle)
            .subscribe(function (response) {
            _this._coordinates = Object.assign(new Array(), JSON.parse(response._body));
            _this.running = false;
        }, function (error) { return _this.running = false; });
    };
    CoordinatesDisplayComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: diagnosis_service_1.DiagnosisService }]; };
    return CoordinatesDisplayComponent;
}());
exports.CoordinatesDisplayComponent = CoordinatesDisplayComponent;
//# sourceMappingURL=coordinates-display.component.js.map


// WEBPACK FOOTER //
// coordinates-display.component.js